export default __webpack_public_path__ + "static/media/emailsSent.27f7952a.svg";